import { useEffect, useState } from 'react';

interface FetchState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

function useFetchJson<T>(jsonFileName: string): FetchState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchJson = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_CONFIG_PATH}/${jsonFileName}`);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const jsonData: T = await response.json();
        setData(jsonData);
      } catch (err: unknown) {
        if (err instanceof Error) setError(err.message);
        else setError('Unknown error');
      } finally {
        setLoading(false);
      }
    }

    fetchJson();
  }, [jsonFileName]);

  return { data, loading, error };
}

export default useFetchJson;
